import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'A.S.M Rafiqullah',
    title: "Frontend Developer",
    desciption: "I design and code beautifully simple things, and I love what I do. Expert in HTML, CSS, Bootstrap, Tailwind, JavaScript, React JS, Node JS, MongoDB, Firebase, Express JS, React Query, React Router, JWT, Stripe Payments System. Currently, I'm working and levelling up with JavaScript.",
    image: 'https://i.ibb.co/k3nxY5k/asmrafiqullah2.jpg',
    resumePdf: resume
}
